import { render, staticRenderFns } from "./OfferTableApproved.vue?vue&type=template&id=722aaf2f"
import script from "./OfferTableApproved.vue?vue&type=script&lang=js"
export * from "./OfferTableApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports